import React from "react";
import { Routes, Route } from "react-router-dom";
import Blog from "./containers/Blog";
import Cart from "./containers/Cart";
import Give from "./containers/Give";
import Hero from "./containers/Hero";
import Podcasts from "./containers/Podcasts";
import Store from "./containers/Store";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Hero />} />
      <Route path="/podcasts" element={<Podcasts />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/store" element={<Store />} />
      <Route path="/give" element={<Give />} />
      <Route path="/cart/:id" element={<Cart />} />
    </Routes>
  );
};

export default App;
